import React, { Component } from "react";

class Learn extends Component {
  render() {
    return (
      <div className="main-content">
        <div className="section-title standalone">
          <p>STAREWAY FILMS TERMS</p>
          <div className="sep" />
        </div>

        <p className="aboutTextStyle">
          <strong>Stareway Films LLC Equipment Lease Contract</strong>
          <br />
          This Equipment Lease Contract is made effective when the current user
          of the Stareway Films LLC website clicks on the “Confirm Order”
          button. This contract is between said current user(“Lessee”, “Client”,
          or “Customer”) and Stareway Films LLC(“Lessor” or “Leasing Company”).
          By clicking on the “Confirm Order” button, Lessee agrees to be bound
          by these terms and conditions, whether or not Lessee has read them.
          Lessor may at its sole discretion modify these terms and conditions at
          any time and any modifications shall become effective immediately as
          posted on its website. By clicking on the “Confirm Order” button,
          Lessee indicates acceptance of the modified terms and conditions. This
          equipment lease contract has been made for the times when individual
          pieces of equipment or multiple pieces of equipment are being rented
          by the client and the client will take the equipment for use without
          the supervision of a professional technician hired by the Leasing
          Company. In such cases when a professional technician is required,
          another contract will have to take place, such contract will be called
          Video Production Service Contract. In consideration of the mutual
          covenants and promises in this Agreement, the receipt and sufficiency
          of which consideration hereby acknowledged, the Lessor leases the
          Equipment to the Lessee, and the Lessee leases the Equipment form the
          Lessor on the following terms:
          <br />
          <br />
          <strong>Lease</strong>
          <br />
          Lessor hereby leases to Lessee, and Lessee hereby leases from Lessor,
          the equipment shown on the website at the order preview
          screen(“Equipment”). Lessor reserves the right to refuse or decline
          leasing Equipment to potential Lessee or client at Lessor´s or
          Company´s sole discretion. Lessor may, at its sole discretion, gather
          information from third parties regarding potential lessee´s past
          rental history and credit worthiness. The Lessor agrees to lease the
          Equipment to the Lessee, and the Lessee agrees to lease the Equipment
          from the Lessor in accordance with the terms set out in this
          Agreement.
          <br />
          <br />
          <strong>Term</strong>
          <br />
          The Agreement commences on the date the Client clicks on the “Confirm
          Button” but the Term of the Lease shall commence on the day of the
          first attempt by the parcel carrier to deliver the item(even if Client
          is not at premises to receive parcel), and expire on the last day of
          the rental period as shown on the checkout page as “Rental Period”,
          which is chosen by the Client. If the Equipment is not returned by
          such date, this Agreement still holds valid until safe and
          satisfactory return of the equipment to the Lessor. The Equipment must
          be return shipped or physically taken to Stareway Films LLC office
          before shipping cut-off time with the courier on the last day of the
          Rental Period. Should Lessee return the Equipment using a shipping
          label not provided by Lessor, and the Equipment is not returned on or
          before the expected return date, Lessor reserves the right to charge
          the Lessee additional Rent for the extra time the Equipment was in
          transit or late. Client hereby gives Lessor permission to contact
          Client via US or International mail, e-mail, telephone, text message
          or social media messaging services such as Facebook or WhatsApp and
          others regarding information on or status of your rental.
          <br />
          <br />
          <strong>Rent and Deposit</strong>
          <br />
          Online rentals will be paid in full at the time of check out. In
          office rentals will be paid in full at time of check out unless there
          is written agreement between Stareway Films LLC and the Client to pay
          50% at day of check out and 50% at day of return.
          <br />
          <br />
          <strong>Use.</strong>
          <br />
          Client or Lessee shall use the Equipment in a careful, safe and
          appropriate manner. The Stareway Films LLC YouTube channel contains
          information on the appropriate use of Equipment that could pose a
          threat to the inexperienced user of said equipment. The Client is
          responsible for his/her own safety during the use of said equipment
          and acknowledges that Stareway Films LLC is not responsible for the
          misuse or inadequate use of said equipment. The Client also
          acknowledges that not all the possible information needed to use the
          equipment in a safe manner is on the Stareway Films LLC YouTube
          channel and that the Client is responsible for researching what the
          appropriate and safe use of said equipment is. The Client shall comply
          with and conform to all manufacturer´s requirements and
          recommendations respecting the equipment and with any applicable law,
          whether local, federal, national, state, municipal, and other laws and
          regulations in any way relating to the possession, use or maintenance
          of the Equipment including any manufacturer´s recommendations,
          warnings and instructions as to the safe use of the Equipment,
          including, but not limited to, environmental and copyright law. The
          Lessee will use the equipment for the purpose for which it was
          designed and not for any other purpose. Unless the Lessee obtains
          prior written consent of the Lessor, the Lessee wil not alter, modify
          or attach anything to the equipment unless the alteration,
          modification or attachment is easily removable without damaging the
          functional capabilities or economic value of the equipment. Stareway
          Films LLC is under the obligation of the law to report any suspicious
          activity relating to the use of the leased equipment to the pertinent
          authorities. Equipment that requires special knowledge on how to be
          used will require that the Client hires a professional technician
          which will be provided by Stareway Films LLC and add its rate to the
          cost of the rental. This will be informed by the Leasing Company to
          the Client first and there will not be added as a cost at a later date
          without letting the Client know from beforehand of its addition to the
          order.
          <br />
          <br />
          <strong>Representations, Warranties and Agreements.</strong> <br />
          Lessee has selected the Equipment without relying upon any suggestion
          or recommendations of Lessor or its employees and Lessee understands
          and agrees that Lessor assumes no responsibility for the Equipment as
          being fit for any particular purpose, this includes the fact that the
          client might not have known of other pieces of equipment that are
          required to make a set piece of equipment to work. The Lessee is
          responsible for ensuring that any necessary peripheral equipment such
          as battery, charger, memory card, cables and other possible pieces of
          equipment required for the Lessee’s intended use of said equipment are
          placed on the order or are available to them in another way. The
          Rental Company will not be held responsible for any loss of monetary
          compensation from the Lessee or loss of time or any other type of
          value. Lessor represents and warrants as follows: (1) the Equipment is
          free from known defects and is in good working condition to the best
          of its knowledge at the inception of the rental; (2) Lessor is
          responsible for routine repair and maintenance of the Equipment prior
          to rental; (3) Lessor has the right to enter into the rental of the
          Equipment. Lessee agrees as follows: (a) except as set forth in
          Lessor´s representations and warranties above, the Equipment is rented
          to Lessee without any warranty or guaranty of any kind, express or
          implied, and specifically, there is no warranty of merchantability or
          fitness for a particular purpose; (b) Lessor shall not be held
          responsible with respect to production downtime, loss of profits,
          extra expense or expenses, indirect, consequential, or punitive
          damages, production delays; and (c) except as set forth in Lessor´s
          representations and warranties above, Lessee is responsible for all
          costs associated with any repair or replacement (without deduction for
          depreciation) of the Equipment necessitated as result of Lessee´s
          usage, possession, transportation or failure to return the Equipment
          for any reason, including, without limitation, as a result of the
          negligence or willful misconduct of Lessee, its employees, agents, or
          contractors. At all times Lessor´s maximum liability in connection
          with the Equipment is limited to the rent paid to Lessor by Lessee. If
          the Equipment is not in good repair, appearance and condition when it
          is returned to the Lessor, the Lessor may make such repairs or may
          cause such repairs to be made as are necessary to put the Equipment in
          a state of good repair, appearance and condition, normal and
          reasonable wear and tear excepted. The Lessor will make the said
          repairs within a reasonable time of taking possession of the Equipment
          and will give the Lessee written notice of and invoices for the said
          repairs. Upon receipt of such invoices, the Lessee will immediately
          reimburse the Lessor for the actual expense of those repairs.
          <br />
          <br />
          <strong>Used Equipment</strong>
          <br />
          Lessee acknowledges that the equipment may be used gear and may be
          cosmetically flawed. However, Lessor warrants that the equipment,
          whether new or used, will be in proper working condition when leased
          to Lessee. Should Lessee discover that the Equipment, as received, is
          not working properly, Lessee agrees to notify Lessor on the subject
          within 3 hours of receipt of equipment. In the event equipment is not
          functioning and/or damaged other than the result of Lessee´s
          negligence or willful acts, Lessee must not attempt to repair or
          modify the equipment himself/herself. Lessee must return such
          non-working equipment to Lessor and Lessor will either replace the
          non-working equipment with a functioning equivalent (“Replacement
          Equipment”) or issue Lessee a credit or full refund of all rental
          charges paid by Lessee at Lessee´s option. The rental charges for all
          such non-working Equipment so returned will commence upon Lessee's
          receipt of the replacement Equipment. Once Lessor receives
          notification of suspected damage of Equipment in transit, Lessor shall
          send such damaged Equipment to the manufacturer for inspection and
          repair. Lessee and Lessor hereby agree to be bound by the damage
          report provided by such manufacturer as to the cause and liability of
          such damage. Lessor shall not be held responsible with respect to
          production downtime, loss of profits, extra expense or expenses,
          indirect, consequential, or punitive damages, production delays.
          <br />
          <br />
          <strong>Typographical Errors</strong>
          <br />
          In the event a product rental rate is listed incorrectly due to errors
          in pricing information received from Lessor's suppliers, Lessor has
          the right to refuse or cancel any orders placed for products listed at
          the incorrect rate whether or not Lessee's credit card has been
          charged. Should Lessor cancel Lessee's order, Lessor will immediately
          credit Lessee's account for the incorrect amount paid.
          <br />
          <br />
          <strong>Order Acceptance Policy</strong>
          <br />
          Your receipt of an electronic or other form of order confirmation does
          not signify Lessor's acceptance of Lessee's order, nor does it
          constitute confirmation of Lessor's offer to rent. Stareway Films LLC
          reserves the right at any time after receipt of Lessee's order to
          accept or decline Lessee's order or to supply less than the quantity
          Lessee ordered of any item for any reason.
          <br />
          <br />
          <strong>Out-of-stock Products and Multiple Product Orders.</strong>
          <br />
          Lessor will ship the Equipment to Lessee as it becomes available.
          There may be times when the Equipment Lessee ordered is out-of-stock
          which will delay fulfilling Lessee's order. Lessor makes no guarantees
          as to availability of Equipment. Any estimate of availability provided
          by Lessor is based on the assumption that each of Lessor's customer
          returns Equipment within the prescribed Rental Period. Lessor will
          keep Lessee informed of any Equipment that Lessee has ordered that are
          out-of-stock and unavailable for immediate shipment. If Equipment is
          out-of-stock or unavailable, Lessee may cancel the order at any time
          prior to shipping. For a multiple product order, Lessor will make
          every attempt to ship all products contained in the order at the same
          time. Equipment that are unavailable at the time of shipment of other
          Equipment will be shipped as they become available unless Lessee
          notifies Lessor of their alternate wishes to this end. Lessee will
          only be charged for Equipment contained in a given shipment, plus any
          applicable shipping charges. Lessee will only be charged for shipping
          at the rate quoted on Lessee's purchase receipt. The entirety of this
          shipping charge may be applied to the first Equipment shipped on an
          order requiring multiple shipments.
          <br />
          <br />
          <strong>Digital Products.</strong>
          <br />
          All Digital Products are sold as-is. Digital products are permanent
          purchases, not rentals. Stareway Films LLC reserves the right to deny
          full or partial refund of amount paid by the Customer for any digital
          purchase due to any reason determined at the sole discretion of
          Stareway Films LLC. This includes any misunderstanding by the Customer
          as to the contents of a digital package, or any perceived or actual
          incongruence between the purchased digital product and any similar
          digital product.
          <br />
          <br />
          <strong>Shipping</strong>
          <br />
          All shipping costs (including returns) are the sole responsibility of
          the Lessee. Lessor does not ship on federal holidays. Lessor cannot
          guarantee the arrival date of the order as that is outside the control
          of Lessor. Any shipping or transit time estimates provided by Lessor
          are estimates only. Lessee is encouraged to order in a timely fashion
          to avoid delays caused by product unavailability or shipping. Lessee
          agrees to obtain and retain the shipping receipt for all return
          shipping until Lessor notifies Lessee of Lessor's receipt of such
          returned product.
          <br />
          <br />
          <strong>Cancellations</strong>
          <br />
          Lessee may cancel a pending reservation up to 24 hours prior to order
          shipment or pick up. Failure to do so will result in a 1 day rental
          (prorated off the 3 day rate) for all Equipment charged to your card.
          Lessee may cancel within 24 hours of placing an order with no fees or
          penalties, as long as order has not shipped. Canceling a shipped order
          will result in extra fees. Lessee may cancel an order once it has
          shipped but such cancellation will be subject to full refund minus: 1
          day rental rate + round trip shipping + cost of the damage waiver (if
          applicable). Lessor reserves the right to cancel any order at any time
          before delivery occurs at its sole discretion.
          <br />
          <br />
          <strong>Insurance and Deposit.</strong> <br />
          Some orders may require that Lessee insure the Equipment for the
          duration of the Rental Period or provide an authorization hold to be
          placed on Lessee's credit card on file in an amount to be determined
          by Lessor until the Equipment has been returned to Lessor in good
          working order. Should Lessee chose to insure the Equipment, Lessee
          shall add Stareway Films LLC as Additional Insureds on Lessee's
          insurance policy and provide Lessor with a Certificate of Insurance at
          the time of the order.
          <br />
          <br />
          <strong>Age</strong>
          <br />
          Due to the value of the Equipment Lessor will not rent Equipment to
          persons under the age of 18. Lessee agrees not to allow any person to
          pick up, or return the Equipment who is under the age of 18.
          <br />
          <br />
          <strong>Repairs</strong>
          <br />
          Lessee agrees not t to attempt to repair or materially alter the
          physical or otherwise makeup of the Equipment under any circumstances
          regardless of fault.
          <br />
          <br />
          <strong>Loss and Damage.</strong> <br />
          Except as set forth in Lessor's representations and warranties above,
          Lessee hereby assumes and shall bear the entire risk of loss and
          damage to the Equipment from any and every cause whatsoever. No loss
          or damage to the Equipment or any part thereof shall impair any
          obligation of Lessee under this Lease. In the event of damage of any
          kind whatever to the Equipment, Lessor may: (a) charge Lessee's credit
          card for the full cost of repair; and (b) repair the Equipment using a
          vendor at Lessor's sole discretion. In addition to repair or
          replacement fees, Lessor may charge Lessee's credit card for a "Loss
          of Use Fee" in the event Lessee did not purchase a damage waiver at
          the time of the initial rental order. "Loss of Use Fee" is equal to
          the daily rental fees Lessor would have been entitled to receive for
          the Equipment had it not been damaged or lost. In the event the
          Equipment becomes damaged beyond repair, Lessee shall pay Lessor the
          full replacement value of the Equipment. Lessee must ensure that the
          Equipment, when returned to Lessor, is clean. Should the returned
          Equipment be deemed dirty in Lessor's sole judgment, Lessor reserves
          the right to charge Lessee a "Cleaning Fee".
          <br />
          <br />
          <strong>Surrender</strong>
          <br />
          Upon the expiration or earlier termination of this Lease, Lessee shall
          return the Equipment to Lessor in good repair, condition and working
          order, ordinary wear and tear resulting from proper use thereof
          excepted, by delivering the Equipment at Lessee's cost and expense via
          the shipping method specified by Lessor. Lessee shall be responsible
          for proper packaging of the returned Equipment using shipping and
          packaging materials provided by Lessor in the order shipment. Lessor's
          acceptance of the Equipment upon return by Lessee shall not represent
          Lessor's determination as to the condition of the returned Equipment.
          Lessor reserves the right to inspect the Equipment within a reasonable
          time after the return of the Equipment and make a determination as to
          whether such returned Equipment was damaged during the Rental Period.
          <br />
          <br />
          <strong>Early Surrender</strong>
          <br />
          Lessee is responsible for setting up the return date. There will be no
          refunds in the case of an early return. Lessee is responsible for the
          planning of how many days he/she will need the equipment.
          <br />
          <br />
          <strong>Damage Waiver</strong>
          <br />
          Lessor offers Lessee the option to purchase a damage waiver ("Damage
          Waiver") for unintentional damage to the Equipment during the Rental
          Period. The determination of whether damage is unintentional and not
          abuse is at the sole discretion of Lessor. In the event of damage
          covered by a Damage Waiver, the Lessee, who has purchased the Damage
          Waiver will pay Lessor a deductible amounting to 15% of the value of
          an item in similar condition to the Equipment rented to Lessee.
          Valuation of the Equipment is within the sole discretion of Lessor. A
          damage waiver does not cover lost or stolen items. A damage waiver
          does not cover liquid damage as that is considered to fall under the
          category of Lessee negligence. Also, any peripheral items in Lessee's
          rental are not covered including lens hoods, battery chargers, front
          and rear caps, cables, etc. ("Peripheral Items"). If Lessee loses
          and/or damages Peripheral Items, Lessee is responsible for the cost of
          replacement of the Peripheral Items even if Lessee purchased a Damage
          Waiver.
          <br />
          <br />
          <strong>Taxes</strong>
          <br />
          Lessee shall keep the Equipment free and clear of all levies, liens
          and encumbrances. Lessee, or Lessor at Lessee's expense, shall report,
          pay and discharge when due all license and registration fees,
          assessments, sales, use and property taxes, gross receipts, taxes
          arising out of receipts from use or operation of the Equipment,
          together with any penalties or interest thereon, imposed by any state,
          federal or local government or any agency, or department thereof,
          whether or not the same shall be assessed against or in the name of
          Lessor or Lessee. Lessee shall indemnify and hold Lessor harmless from
          any taxes, fees, and penalties arising out of Lessee's lease, use and
          possession of the Equipment except for those taxes, fees and penalties
          based upon Lessor's income.
          <br />
          <br />
          <strong>Indemnity.</strong> <br />
          Lessee shall indemnify Lessor against, and hold Lessor harmless from,
          any and all claims, actions, suits, proceedings, costs, expenses,
          damages and liabilities, including reasonable attorney's fees and
          costs, arising out of, connected with, or resulting from Lessee's use
          of the Equipment, including without limitation the selection,
          possession, use, operation, or return of the Equipment.
          <br />
          <br />
          <strong>Default</strong>
          <br />
          If Lessee fails to pay any rent or other amount herein provided within
          ten (10) days after the same is due and payable, or if Lessee fails to
          observe, keep or perform any other provision of this Lease required to
          be observed, kept or performed by Lessee, Lessor shall have the right
          to exercise any one or more of the following remedies:
          <br />
          a. To charge Lessee's credit card on file for all amounts due
          (including any late fees) and owing.
          <br />
          b. To sue for and recover all rents, and other payments, then accrued
          or thereafter accruing.
          <br />
          c. To take possession of the Equipment, without demand or notice,
          wherever same may be located, without any court order or other process
          of law. Lessee hereby waives any and all damages occasioned by such
          taking of possession.
          <br />
          d. To terminate this Lease.
          <br />
          e. To pursue any other remedy at law or in equity.
          <br />
          Notwithstanding any repossession or any other action which Lessor may
          take, Lessee shall be and remain liable for the full performance of
          all obligations on the part of the Lessee to be performed under this
          Lease. All of Lessor's remedies are cumulative, and may be exercised
          concurrently or separately.
          <br />
          <br />
          <br />
          <strong>Bankruptcy</strong>
          <br />
          Neither this Lease nor any interest therein is assignable or
          transferable by operation of law. If any proceeding under the
          Bankruptcy Act, as amended, is commenced by or against the Lessee, or
          if the Lessee is adjudged insolvent, or if Lessee makes any assignment
          for the benefit of his creditors, or if a writ of attachment or
          execution is levied on the Equipment and is not released or satisfied
          within ten (10) days thereafter, or if a receiver is appointed in any
          proceeding or action to which the Lessee is a party with authority to
          take possession or control of the Equipment, Lessor shall have and may
          exercise the option to, without notice, immediately terminate the
          Lease. The Lease shall not be treated as an asset of Lessee after the
          exercise of said option.
          <br />
          <br />
          <strong>Ownership</strong>
          <br />
          The Equipment is, and shall at all times be and remain, the sole and
          exclusive property of Lessor; and the Lessee shall have no right,
          title or interest therein or thereto except as expressly set forth in
          this Lease.
          <br />
          <br />
          <strong>Additional Documents</strong>
          <br />
          If Lessor shall so request, Lessee shall execute and deliver to Lessor
          such documents as Lessor shall deem necessary or desirable for
          purposes of recording or filing to protect the interest of Lessor in
          the Equipment including, but not limited to a UCC financing statement.
          <br />
          <br />
          <strong>Entire Agreement</strong>
          <br />
          This instrument constitutes the entire agreement between the parties
          on the subject matter hereof unless there is an additional video
          production service contract between the parties to which the equipment
          is leased as well.
          <br />
          <br />
          <strong>Notices</strong>
          <br />
          Service of all notices under this Agreement shall be sufficient if
          given personally or by certified mail, return receipt requested,
          postage prepaid, at the address hereinafter set forth, or to such
          address as such party may provide in writing from time to time.
          <br />
          <br />
          <strong>Governing Law</strong>
          <br />
          This Lease shall be construed and enforced according to laws of the
          State of Texas.
          <br />
          <br />
          <br />{" "}
        </p>
      </div>
    );
  }
}

export default Learn;



// WEBPACK FOOTER //
// ./src/components/terms.js